import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type PonOvisRequestParams = {
  isModalOpen: boolean;
  car_id?: number;
  vin_nr?: string;
  dealer_location_id?: number;
};

export const usePonOvis = ({ isModalOpen, car_id, vin_nr, dealer_location_id }: PonOvisRequestParams) =>
  useTypedQuery({
    queryKey: AppointmentDetailsKeys.ponOvisEvents,
    queryFn: async ({ baseUrl, endpoint }) =>
      (await ApiInstance.post(endpoint, { car_id, vin_nr, ...(dealer_location_id && { dealer_location_id }) }, baseUrl)).data.vehicleEvents,
    enabled: isModalOpen && ((car_id && car_id > 0) || (Boolean(vin_nr) && Boolean(dealer_location_id)))
  });
